import { render, staticRenderFns } from "./CollectionCountByDay.vue?vue&type=template&id=663705bc&scoped=true"
import script from "./CollectionCountByDay.vue?vue&type=script&lang=js"
export * from "./CollectionCountByDay.vue?vue&type=script&lang=js"
import style0 from "./CollectionCountByDay.vue?vue&type=style&index=0&id=663705bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663705bc",
  null
  
)

export default component.exports